"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HrOptionsPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const slate_react_1 = require("slate-react");
const context_1 = require("@jsonjoy.com/ui/lib/4-card/Popup/context");
const EditorContextPopup_1 = require("../../../chrome/EditorContextPopup");
const HrOptions_1 = require("./HrOptions");
const state_1 = require("./state");
const use_t_1 = require("use-t");
const HrOptionsPopupBody = () => {
    const [t] = (0, use_t_1.useT)();
    const state = (0, state_1.useHrOptionsState)();
    return (React.createElement(EditorContextPopup_1.EditorContextPopup, { title: t('Separator details'), subtitle: t('Configure the line style, width, height, and optional text.'), minWidth: 320, onCancel: state.cancel, onApply: state.apply },
        React.createElement(HrOptions_1.HrOptions, null)));
};
const HrOptionsPopup = ({ element }) => {
    const editor = (0, slate_react_1.useSlateStatic)();
    const popup = (0, context_1.usePopup)();
    return (React.createElement(state_1.HrOptionsStateProvider, { editor: editor, element: element, closePopup: () => popup?.close() },
        React.createElement(HrOptionsPopupBody, null)));
};
exports.HrOptionsPopup = HrOptionsPopup;
